class ProductStitcher extends HTMLElement {


    playVisibleProductVideos(container = document) {
      const videos = container.querySelectorAll('.product__video');

      videos.forEach((video) => {
        try {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          video.setAttribute('autoplay', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('loop', '');

          // reload + play after ajax DOM swap
          video.load();

          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((err) => {
              console.log('Video autoplay blocked:', err);
            });
          }
        } catch (e) {
          console.log('Video play error:', e);
        }
      });
    }

  constructor() {
      super();

      this.selectors = {
          mainSection: "[js-hb-main-product]",
          productReviews: "[js-hb-nector-review]",
          productList: "[js-hb-product-list]",
          productRecommendation: "[js-hb-product-recommendation]",
          stitcherItem: "[js-hb-product-switcher]",
          faqSection: "[js-hb-secondary-faq-section]",
          pdpAccordion: "[js-hb-faq-section]",
          fabricDropdown: "fabric-dropdown",
          mobilefabricDropdown:  "mobile-fabric-dropdown"
      };

      this.mainSection = this.closest(this.selectors.mainSection);
    
      this.sections = {
          mainProduct: { 
              element: this.mainSection, 
              selector: this.selectors.mainSection, 
              initEvents: ["size-guide:init", "product-features-accordion:init", "secondaryPDPSlider:init", "update-size-label2:init", "update-size-label:init"] 
          },
           productReviews: { 
               element: document.querySelector(this.selectors.productReviews), 
               selector: this.selectors.productReviews 
           },
           productList: { 
               element: document.querySelector(this.selectors.productList), 
               selector: this.selectors.productList,
               initEvents: ["pdp-productlist:init"]
           },
           productRecommendation: { 
               element: document.querySelector(this.selectors.productRecommendation), 
               selector: this.selectors.productRecommendation,
           },
          faqSection: { 
               element: document.querySelector(this.selectors.faqSection), 
               selector: this.selectors.faqSection,
               initEvents: ["secondaryPDPFaqSection:init"]
           },
          pdpAccordion: { 
               element: document.querySelector(this.selectors.pdpAccordion), 
               selector: this.selectors.pdpAccordion,
               initEvents: ["pdp-accordion:init"]
           },
      };

      this.stitcherItems = this.querySelectorAll(this.selectors.stitcherItem);
      this.fabricDropdowns = document.querySelectorAll(this.selectors.fabricDropdown);
      this.mobilefabricDropdowns = document.querySelectorAll(this.selectors.mobilefabricDropdown);
      this.init();
  }

  init() {
      // this.stitcherItems.forEach(stitcherItem =>
      //     stitcherItem.addEventListener("click", this.renderSectionFromFetch.bind(this))
      // );
      this.stitcherItems.forEach(stitcherItem =>
  stitcherItem.addEventListener("click", (e) => {
    console.log('Stitcher item clicked:', stitcherItem, e);

    this.fabricDropdowns.forEach(drop => {
      const val = drop.getAttribute("value") || null;
      const text = drop.getAttribute("text") || null;

      console.log("Dropdown current state:", { val, text });

      if (val) {
        drop.value = val;
        drop.setAttribute("value", val);
      }
      if (text) {
        drop.setAttribute("text", text);
      }
    });

    this.mobilefabricDropdowns.forEach(drop => {
      const val = drop.getAttribute("value") || null;
      const text = drop.getAttribute("text") || null;

      console.log("Dropdown current state:", { val, text });

      
      if (val) {
        drop.value = val;
        drop.setAttribute("value", val);
      }
      if (text) {
        drop.setAttribute("text", text);
      }
    });

    this.renderSectionFromFetch(e);
  })
);

      // this.fabricDropdowns.forEach(drop =>
      //   drop.addEventListener("change", (e) => {
    
      //     const handle = e.detail?.value;              
      //     console.log(handle);
          
      //     if (handle) this._renderByHandle(handle);
    
    
      //   })
      // );
// Desktop Fabric Dropdown change
this.fabricDropdowns.forEach(drop =>
    drop.addEventListener("change", (e) => {
      const wrapper = e.currentTarget.closest(".prodocut-tab-wrapper-inner");

      // 1️⃣ Get active category text dynamically
      let activeCategory = wrapper
    ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
    ?.textContent.trim().toLowerCase();

  if (activeCategory) {
    activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
  }

      if (!activeCategory) return;

      // normalize spaces, underscores, etc.
      // activeCategory = activeCategory.replace(/\s+/g, "-");

      // 2️⃣ Get selected dropdown item
      const selectedItem = wrapper?.querySelector("[js-fabric-dropdown-item].selected");
      if (!selectedItem) return;

      // 3️⃣ Find dataset key dynamically (must include activeCategory + "product")
      let matchingKey = Object.keys(selectedItem.dataset).find(key => {
        const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        return kebabKey.includes(activeCategory);
      });
      if (!matchingKey && drop.hasAttribute('js-display-default-product')) {
      matchingKey = Object.keys(selectedItem.dataset)[0];
    }
      if (!matchingKey) {
        console.warn(`No dataset key found for category: ${activeCategory}`);
        console.log("Available dataset keys:", Object.keys(selectedItem.dataset));
        return;
      }

      // 4️⃣ Get product handle & render
      const productHandle = selectedItem.dataset[matchingKey];
      if (productHandle) {
        this._renderByHandle(productHandle);
      }
    })
);



      this.mobilefabricDropdowns.forEach(drop =>
  drop.addEventListener("change", (e) => {
    const wrapper = e.currentTarget.closest(".prodocut-tab-wrapper-inner.product-tab.medium-up--hide");

    // 1️⃣ Get active category text dynamically
      let activeCategory = wrapper
      ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
      ?.textContent.trim().toLowerCase();

      if (activeCategory) {
        activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
      }

      if (!activeCategory) return;

      // normalize spaces, underscores, etc.
      // activeCategory = activeCategory.replace(/\s+/g, "-");

      // 2️⃣ Get selected dropdown item
      const selectedItem = wrapper?.querySelector("[js-mobile-fabric-dropdown-item].selected");
      if (!selectedItem) return;

      // 3️⃣ Find dataset key dynamically (must include activeCategory + "product")
      let matchingKey = Object.keys(selectedItem.dataset).find(key => {
        const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        return kebabKey.includes(activeCategory);
      });
      if (!matchingKey && drop.hasAttribute('js-display-default-product')) {
      matchingKey = Object.keys(selectedItem.dataset)[0];
    }
      if (!matchingKey) {
        console.warn(`No dataset key found for category: ${activeCategory}`);
        console.log("Available dataset keys:", Object.keys(selectedItem.dataset));
        return;
      }

      // 4️⃣ Get product handle & render
      const productHandle = selectedItem.dataset[matchingKey];
      if (productHandle) {
        this._renderByHandle(productHandle);
      }
  })
);
      this.mainCategoryTab()
      this.productsTab()
  }

   _renderByHandle(handle) {
    this.updateLoading();
    Object.values(this.sections).forEach(({ element, selector, initEvents = [] }) => {
      if (element) this.renderSection(handle, element, selector, ...initEvents);
      console.log('calledfromrenderbyhandlefunction');

    });
  }
  renderSectionFromFetch(evt) {
      evt.preventDefault();
      const { currentTarget } = evt;
      const handle = currentTarget.getAttribute("data-product-handle");
      this.updateLoading();
      Object.values(this.sections).forEach(({ element, selector, initEvents = [] }) => {
          element && this.renderSection(handle, element, selector, currentTarget, ...initEvents);
      });
      console.log('calledfromrenderbyhandlefunction');
  }

  updateURLHash(handle) {
      const url = `/products/${handle}`;
      window.history.replaceState({}, '', url);
  }

  updateLoading() {
      this.sections.mainProduct.element.classList.add("section--loading");
  }

  renderSection(handle, container, selector, currentTarget, ...initEvents) {
      let sectionId = container.getAttribute("data-section");
      const url = `/products/${handle}?section_id=${sectionId}`;
      this.ajaxSection(url, container, selector, handle, currentTarget, initEvents);
  }

  ajaxSection(url, container, selector, handle, currentTarget,  initEvents = []) {
    // older code start 
      // const currentDropdown   = document.querySelector("fabric-dropdown");
      // const currentFabric     = currentDropdown?.value;
      // const mobilecurrentDropdown   = document.querySelector("mobile-fabric-dropdown");
      // const mobilecurrentFabric     = mobilecurrentDropdown?.value;
    // older code end   
    const currentDropdown = document.querySelector("fabric-dropdown");
    const currentFabricValue = currentDropdown?.value;
    const currentFabricLabel = currentDropdown?.getAttribute("text");

    // mobile dropdown
    const mobilecurrentDropdown = document.querySelector("mobile-fabric-dropdown");
    const mobilecurrentFabricValue = mobilecurrentDropdown?.value;
    const mobilecurrentFabricLabel = mobilecurrentDropdown?.getAttribute("text");
    // console.log(mobilecurrentFabricValue,mobilecurrentFabricLabel,"mobilecurrentFabricValue-mobilecurrentFabricLabel");
    // console.log(currentFabricValue,currentFabricLabel,"currentFabricValue-currentFabricLabel");
    // console.log(currentTarget,'this')
    
      const previouslySelectedSize = container.querySelector("hb-product-variants [js-size-input]:checked");
      fetch(url)
          .then(response => response.text())
          
          .then(html => {
              const ajaxContainer = new DOMParser()
                  .parseFromString(html, 'text/html')
                  .querySelector(selector);

              if (ajaxContainer && selector != this.selectors.productReviews) {
                  container.innerHTML = ajaxContainer.innerHTML;
              }
              if(selector === this.selectors.mainSection) { 
                theme.sections.register('product', theme.Product);
                const updatedVariantSizes = container.querySelectorAll("hb-product-variants [js-size-input]")
             
                if(previouslySelectedSize){
                  updatedVariantSizes.forEach((variantSize) => {
                    if(variantSize.value == previouslySelectedSize.value){
                      variantSize.nextElementSibling.click()
                      setTimeout(function(){
                        variantSize.nextElementSibling.click()
                      },500)
                    }
                  })
                }

                if (document.querySelector('[js-hb-product-switcher].selected')?.getAttribute("data-view-selection") === "crew") {
                  document.body.classList.add("crew_selected");
                } else {
                  document.body.classList.remove("crew_selected");
                }

                if (document.querySelector('[js-hb-product-switcher].selected')?.getAttribute("data-view-selection") === "365") {
                  document.body.classList.add("hb_collection__365-selected");
                } else {
                  document.body.classList.remove("hb_collection__365-selected");
                }

                document.dispatchEvent(new CustomEvent('pdp-productlist:init'))
                document.dispatchEvent(new CustomEvent('changeReviewsWidgetColors:init'))

                 requestAnimationFrame(() => {
                  this.playVisibleProductVideos(container);
                });


                // [nector] to updat the points earning widget
              	const customerEarnElement = container.querySelector('script[data-op="customerearn"]');
                if (customerEarnElement) {
                  const customerEarnParent = customerEarnElement.parentElement;
                  const clonedCustomerEarnElement = document.createElement('script');

                  // Copy all attributes from the original element to the cloned element
                  Array.from(customerEarnElement.attributes).forEach(attr => {
                    clonedCustomerEarnElement.setAttribute(attr.name, attr.value);
                  });

                  customerEarnParent.removeChild(customerEarnElement);

                  // Append the cloned element to the parent
                  customerEarnParent.appendChild(clonedCustomerEarnElement);

                            setTimeout(() => {
                    // Remove the existing script tag with the specified URL
                    document.querySelectorAll('script[src^="https://cdn.nector.io/nector-static/no-cache/reward-widget/package/customerearn.min.js"]').forEach(element => element.remove());

                    // Create a new script element with the updated URL and attributes
                    const customerEarnScript = document.createElement("script");
                    customerEarnScript.src = "https://cdn.nector.io/nector-static/no-cache/reward-widget/package/customerearn.min.js" + `?t=${Date.now()}`;
                    customerEarnScript.setAttribute("type", "module");

                    // Append the new script element to the body
                    document.body.appendChild(customerEarnScript);
                  }, 1000)
                }

                const newDropdown = container.querySelector("fabric-dropdown") || document.querySelector("fabric-dropdown");

if (newDropdown && currentFabricValue) {
  newDropdown.setAttribute("value", currentFabricValue);
  if (currentFabricLabel) {
    newDropdown.setAttribute("text", currentFabricLabel);
    const selectedTextEl = newDropdown.querySelector("[js-fabric-dropdown-selected-text]");
    if (selectedTextEl) selectedTextEl.textContent = currentFabricLabel;
  }
}

// mobile code 
const mobile_newDropdown = container.querySelector("mobile-fabric-dropdown") || document.querySelector("mobile-fabric-dropdown");


if (mobile_newDropdown && mobilecurrentFabricValue) {
  mobile_newDropdown.setAttribute("value", mobilecurrentFabricValue);
  if (mobilecurrentFabricLabel) {
    mobile_newDropdown.setAttribute("text", mobilecurrentFabricLabel);
    const mobileselectedTextEl = mobile_newDropdown.querySelector("[js-mobile-fabric-dropdown-selected-text]");
    if (mobileselectedTextEl) mobileselectedTextEl.textContent = mobilecurrentFabricLabel;
  }
}
function filterFabricOptions(wrapper) {
    // 1️⃣ Get active category
    let activeCategory = wrapper
    ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
    ?.textContent.trim().toLowerCase();

  if (activeCategory) {
    activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
  }

    if (!activeCategory) return;

    // 2️⃣ Loop through fabric options
    const fabricOptions = wrapper.querySelectorAll("[js-fabric-dropdown-item]");
    fabricOptions.forEach(item => {
      // 3️⃣ Find matching dataset key dynamically
      const matchingKey = Object.keys(item.dataset).find(key => {
        const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        return kebabKey.includes(activeCategory);
      });
        

      // 4️⃣ Show if product exists, hide if not
      if (matchingKey && item.dataset[matchingKey]) {
        item.style.display = "";   // ✅ show
      } else {
        item.style.display = "none"; // 🚫 hide
      }
    });
  }
filterFabricOptions(this.mainSection);






                // deskttop older code start 
// const newDropdown =
//   container.querySelector("fabric-dropdown") ||
//   document.querySelector("fabric-dropdown");
//   console.log(newDropdown,'newDropdown');
//   const newmobileDropdown =
//   container.querySelector("mobile-fabric-dropdown") ||
//   document.querySelector("mobile-fabric-dropdown");
//   console.log(newmobileDropdown,'newmobileDropdown');


// desktop  
// if (newDropdown && currentFabric) {
//   newDropdown.setAttribute("value", currentFabric);  
// }

                // fabric dropdown related code 
                // const dropItems = newDropdown.querySelectorAll('[js-fabric-dropdown-container] [data-cotton-trunk-product] ');
                
                // if(currentFabric){
                //   dropItems.forEach((dropItem) => {
                //       dropItem.classList.remove('selected');
                //   });
                //   dropItems.forEach((dropItem) => {
                //     const dropItemData = dropItem.getAttribute('data-cotton-trunk-product')
                //     if(dropItemData == currentFabric){
                //       if(!dropItem.classList.contains('selected')){
                //           dropItem.classList.add('selected');
                //           var selectedText = dropItem.textContent;
                //           newDropdown.querySelector('[js-fabric-dropdown-selected-text]').innerHTML = selectedText;
                //       }
                //     }
                //   })
                // }
// deskttop older code end 

// mobile dropdown




// if (newmobileDropdown && mobilecurrentFabric) {
//   newmobileDropdown.setAttribute("value", mobilecurrentFabric);  
// }

                // fabric dropdown related code 
                // const mobiledropItems = newmobileDropdown.querySelectorAll('[js-fabric-dropdown-container] [data-fabric-product]');
                
                // if(mobilecurrentFabric){
                //   mobiledropItems.forEach((dropItem) => {
                //       dropItem.classList.remove('selected');
                //   });
                //   mobiledropItems.forEach((dropItem) => {
                //     const dropItemData = dropItem.getAttribute('data-fabric-product')
                //     if(dropItemData == mobilecurrentFabric){
                //       if(!dropItem.classList.contains('selected')){
                //           dropItem.classList.add('selected');
                //           var selectedText = dropItem.textContent;
                //           newmobileDropdown.querySelector('[js-fabric-dropdown-selected-text]').innerHTML = selectedText;
                //       }
                //     }
                //   })
                // }


              }

              if(selector === this.selectors.productReviews) {
                const newProductId = ajaxContainer.querySelector('script').getAttribute('data-product_id');
                console.log({ newProductId })
                const script_hb = document.createElement('script');
                script_hb.src = "https://cdn.nector.io/nector-static/no-cache/reward-widget/mainloader.min.js";
                script_hb.setAttribute("data-api_key", "c25d2022cdfbc0d71d658767d386feb8ecaa6227f7678b867b3e9a5fdde81ab6");
                script_hb.setAttribute("data-platform", "shopify");
                script_hb.setAttribute("async", "");
                script_hb.setAttribute("data-platform_url", "https://platform.nector.io");
                script_hb.setAttribute("data-op", "review_list");
                script_hb.setAttribute("data-view_type", "row");
                script_hb.setAttribute("data-hide_total_review_count", "true");
                script_hb.setAttribute("data-product_id", newProductId);
                script_hb.setAttribute("data-websdk_url", "https://websdk.nector.io");
                script_hb.setAttribute("data-entity_id", "6180bc3e-14d2-4c9e-9bb2-b2cfd08159a6");
                script_hb.setAttribute("data-default_reviews_sort", "created_at");  

                const scripts = document.querySelectorAll("script[src]")

                scripts.forEach(script => {
                    const src = script.getAttribute('src');
                    if(src.includes('https://cdn.nector.io')) {
                        script.remove();
                    }
                })

                container.innerHTML = '';
                container.append(script_hb);

                // document.querySelector("[js-hb-faq-section]").querySelector('[js-accordion-panel].review .panel_inner').append(script_hb);

                script_hb.onload = function() {
                  document.querySelectorAll('script[src="https://cdn.nector.io/nector-static/no-cache/reward-widget/package/reviews.min.js"]').forEach(element => element.remove());
              
                  const reviewScript = document.createElement("script");
                  reviewScript.src = "https://cdn.nector.io/nector-static/no-cache/reward-widget/package/reviews.min.js" + `?timestamp=${Date.now()}`;
                  reviewScript.setAttribute("type", "module");
                  document.body.appendChild(reviewScript);
                }
              }
// const newDropdown =
//   container.querySelector("fabric-dropdown") ||
//   document.querySelector("fabric-dropdown");

// if (newDropdown && currentFabric) {
//   newDropdown.setAttribute("value", currentFabric);  
// }

// newDropdown.addEventListener("change", (e) => {
//   const newHandle = e.detail?.value;
  

//   if (newHandle && newHandle !== currentFabric) {
//     this._renderByHandle(newHandle);
//   }
// });
              initEvents.forEach(eventName => document.dispatchEvent(new CustomEvent(eventName)));
              this.updateURLHash(handle);
          })
          .catch(err => {
              console.log(err)
          })
  }

  mainCategoryTab() {
    const mainCategory = this.mainSection.querySelectorAll('[js-hb-main-category-item]');
    const subCategory = this.mainSection.querySelectorAll('[js-hb-sub-category]');
    const productsTabPanel = this.mainSection.querySelectorAll('[js-hb-product-tab-body]');
  
    mainCategory.forEach((category, categoryIndex) => {
      category.addEventListener('click', () => {
        currentTabType = category.getAttribute('data-value');
  
        // Remove "active" class from all elements
        mainCategory.forEach(item => item.classList.remove('active'));
        subCategory.forEach(item => item.classList.remove('active'));
        productsTabPanel.forEach(item => item.classList.remove('active'));
  
        // Add "active" class to the clicked category
        category.classList.add('active');
        const currentSubCategory = subCategory[categoryIndex];
        currentSubCategory.classList.add('active');
  
        const subCategoryHeaders = currentSubCategory.querySelectorAll('[js-hb-product-tab-header]');
        subCategoryHeaders.forEach(header => header.classList.remove('active'));
  
        // Determine which sub-category tab to activate
        const activeSubCategory = this.mainSection.querySelector('[js-hb-sub-category].active');
        const activeCategory = activeSubCategory.querySelector('[js-hb-product-tab-header].active');
  
        if (activeCategory) {
          activeCategory.click();
        } else {
          const firstTabHeader = activeSubCategory.querySelector('[js-hb-product-tab-header]:first-child');
          if (firstTabHeader) firstTabHeader.click();
        }
      });
    });
  }
  
productsTab() {
  const tabHeaders = this.mainSection.querySelectorAll('[js-hb-product-tab-header]');

  // 🔹 Helper: Hide fabric options if product not available for active tab
  function filterFabricOptions(wrapper) {
    // 1️⃣ Get active category
    let activeCategory = wrapper
    ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
    ?.textContent.trim().toLowerCase();

  if (activeCategory) {
    activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
  }

    if (!activeCategory) return;

    // 2️⃣ Loop through fabric options
    const fabricOptions = wrapper.querySelectorAll("[js-fabric-dropdown-item]");
    fabricOptions.forEach(item => {
      // 3️⃣ Find matching dataset key dynamically
      const matchingKey = Object.keys(item.dataset).find(key => {
        const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        return kebabKey.includes(activeCategory);
      });
      // const matchingKey = Object.keys(item.dataset)
      //   .find(key => {
      //   key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
      //   return matchingKey.includes(activeCategory);
      //   })

      // 4️⃣ Show if product exists, hide if not
      if (matchingKey && item.dataset[matchingKey]) {
        item.style.display = "";   
      } else {
        item.style.display = "none"; 
      }
    });
  }

  tabHeaders.forEach(tabHeader => {
    tabHeader.addEventListener('click', () => {
      // Remove "active" class from all headers and panels
      tabHeaders.forEach(header => header.classList.remove('active'));
      const tabPanels = this.mainSection.querySelectorAll('[js-hb-product-tab-body]');
      tabPanels.forEach(panel => panel.classList.remove('active'));

      // Activate the clicked tab
      tabHeader.classList.add('active');
      const index = tabHeader.getAttribute('data-product-tab-header-index');
      const activePanel = this.mainSection.querySelector(`[data-product-tab-body-index="${index}"]`);
      if (activePanel) activePanel.classList.add('active');

      // Handle product selection
      const categoryProducts = activePanel.querySelectorAll('[js-hb-product-switcher]');
      if (Array.from(categoryProducts).some(product => product.classList.contains('selected'))) {
        const selectedProduct = activePanel.querySelector('.selected[js-hb-product-switcher]');
        if (selectedProduct) selectedProduct.click();
      } else if (categoryProducts.length > 0) {
        categoryProducts[0].classList.add('selected');
        categoryProducts[0].click();
      }

      // 🔹 After tab change → filter fabric options
      filterFabricOptions(this.mainSection);
    });
  });
}


}

customElements.define('product-stitcher', ProductStitcher);


function secondaryPDPFaqSection() {
  let accordianClick = document.querySelectorAll("[js-accordian-click]");
  let accordianItem = document.querySelectorAll("[js-accordian-item]");
  accordianClick.forEach(function(el) {
    el.addEventListener("click", function() {
        let clickItem = el.closest("[js-accordian-item]");
        isActive = clickItem.classList.contains("active"); 
        accordianItem.forEach(function(item) {
            item.classList.remove("active");
        })
        if(!isActive) {
            clickItem.classList.add("active")
        }
    })
  })
}

secondaryPDPFaqSection();

document.addEventListener('secondaryPDPFaqSection:init', secondaryPDPFaqSection);


class ProductVariants extends HTMLElement {
  constructor() {
    super();
    this.requiredDataStractured = {
      s: [],
      m: [],
      l: [],
      xl: [],
      xxl: []
    }
    this.getProductsData();
    this.addEventListener('change', this.onVariantChange);
  }

  // getProductsData() {
  //   const productsData = [];

  //   const stringProductsData = document.querySelectorAll('script[js-product-json]');
    
  //   stringProductsData.forEach((productDataString) => {
  //       const productData = JSON.parse(productDataString.textContent);
  //       productsData.push(productData);
  //   });
  //   console.log({productsData})
  //   productsData.forEach(product => {
  //     product.variants.forEach(variant => {
  //       this.requiredDataStractured[variant.title.toLowerCase()] = [
  //         ...this.requiredDataStractured[variant.title.toLowerCase()], 
  //         { 
  //           "productId": product.product_id,
  //           "available": variant.available 
  //         }
  //       ]
  //     })
  //   })
  // }
  getProductsData() {
    const productsData = [];

    const stringProductsData = document.querySelectorAll('script[js-product-json]');
    
    stringProductsData.forEach((productDataString) => {
        const productData = JSON.parse(productDataString.textContent);
        productsData.push(productData);
    });
    console.log({productsData})
    productsData.forEach(product => {
    product.variants.forEach(variant => {
        const key = variant.title.toLowerCase();
        
        // Ensure the key exists in the object before spreading
        if (!this.requiredDataStractured[key]) {
            this.requiredDataStractured[key] = [];
        }
        
        this.requiredDataStractured[key] = [
            ...this.requiredDataStractured[key], 
            { 
                "productId": product.product_id,
                "available": variant.available 
            }
        ];
    });
});

  }

  onVariantChange(e) {
    this.updateOptions();
    const selectedSize = this.updateOptions().toLowerCase();
    this.productSoldOut(selectedSize);
  }

  productSoldOut(selectedSize) {
    this.requiredDataStractured[selectedSize].forEach((product) => {
      const productElement = document.querySelector(`[js-hb-product-switcher][data-product-id="${product.productId}"]`);
      if(productElement){
        if(product.available) {
        document.querySelector(`[js-hb-product-switcher][data-product-id="${product.productId}"]`).classList.remove('soldout');
      } else {
        document.querySelector(`[js-hb-product-switcher][data-product-id="${product.productId}"]`).classList.add('soldout');
      }
      }
      else {
      console.warn(`Product switcher not found for productId: ${product.productId}`);
    }
    })
  }

  updateOptions() {
    return [...this.querySelectorAll('[js-size-input]:checked')].map((select) => select.value).toString();
  }
  

} 

customElements.define('hb-product-variants', ProductVariants);



class FabricDropdown extends HTMLElement {
  static get observedAttributes() { return ["value"]; }
  constructor() {
    super();

    this.selectors = {
      header:           "[js-fabric-dropdown-header]",
      arrow:            "[js-fabric-dropdown-arrow]",
      list:             "[js-fabric-dropdown-list]",
      item:             "[js-fabric-dropdown-item]",
      selectedText:     "[js-fabric-dropdown-selected-text]",
      container:        "[js-fabric-dropdown-container]"   
    };

    
    this.header       = this.querySelector(this.selectors.header);
    this.arrow        = this.querySelector(this.selectors.arrow);
    this.list         = this.querySelector(this.selectors.list);
    this.items        = this.querySelectorAll(this.selectors.item);
    this.selectedText = this.querySelector(this.selectors.selectedText);

    
    this.isOpen = false;
    this.value  = null;         

    this.init();
  }
  // connectedCallback() {
  //   const initial = this.getAttribute("value");
  //     if (initial) {
        
  //       requestAnimationFrame(() => (this.selectedValue = initial));
  //     } else {
  //       this._showPlaceholder();
  //     }
  // }


  connectedCallback() {
  const initial = this.getAttribute("value");

  // Case 1: If "value" attribute is passed, select it
  if (initial) {
    requestAnimationFrame(() => (this.selectedValue = initial));
  } else {
    // Case 2: Auto-select first matching item for the active category
    requestAnimationFrame(() => {
      const wrapper = this.closest(".prodocut-tab-wrapper-inner");
      let activeCategory = wrapper
        ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
        ?.textContent.trim().toLowerCase();

      if (activeCategory) {
        activeCategory = activeCategory.replace(/\s+/g, "-");
      }
      const showAll = this.hasAttribute('js-display-default-product');
      // Try to find an item whose dataset matches the active category
      this.items.forEach(item => {
        if(showAll){
          item.style.display = "";
        }
        else{
          const hasMatch = Object.keys(item.dataset).some(key => {
          const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
          return activeCategory && kebabKey.includes(activeCategory) && item.dataset[key];
        });

        item.style.display = hasMatch ? "" : "none";
        }
        
      });

      const visibleItem = Array.from(this.items).some(el => el.style.display !== "none");
      if (!visibleItem) {
        this._showPlaceholder();
      }
    });
  }
}




  
  attributeChangedCallback(name, oldVal, newVal) {
      console.log(name, oldVal, newVal);
      
      if (name === "value") {
        if (newVal) {
          requestAnimationFrame(() => {
            this.selectedValue = newVal;
          });
        } else {
          this.value = null;
          this._clearSelectionStyles();
          this._showPlaceholder();
        }
      }
  }

  get selectedValue() { return this.value; }
  set selectedValue(val) {
    const match = Array.from(this.items)
      .find(i => i.dataset.fabricProduct === val);
    if (match) this._selectItem({ currentTarget: match, silent: true });
  }

  
  init() {    
    this.header.addEventListener("click",  this._toggleDropdown.bind(this));

    this.items.forEach(item =>
      item.addEventListener("click", this._selectItem.bind(this))
    );

    document.addEventListener("click", this._handleOutside.bind(this));

    // if (this.items.length && !this.value) {
    //   this._selectItem({ currentTarget: this.items[0], silent: true });
    // }
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._handleOutside.bind(this));
  }

  _toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.list.classList.toggle("open",   this.isOpen);
    this.list.classList.toggle("closed", !this.isOpen);
    console.log(this.list)
    this.setAttribute("aria-expanded", this.isOpen);
    if (this.isOpen) {
      document.body.classList.add("active_dropdown");
    } else {
      document.body.classList.remove("active_dropdown");
    }
  }

//   _selectItem(evt) {
//   const el   = evt.currentTarget || evt.target;
//   const code = el.dataset.fabricProduct;
//   const label = el.textContent.trim();

//   if (code === this.value) {
//     this._toggleDropdown();
//     return;
//   }

//   this._clearSelectionStyles();
//   el.classList.add("selected");
//   this.selectedText.textContent = label;

//   this.value = code;
//   this.setAttribute("value", code);
//   this.setAttribute("text", label);

//   if (!evt.silent) {
//     this.dispatchEvent(new CustomEvent("change", {
//       bubbles: true,
//       detail: { value: code }
//     }));
//   }

//   this._toggleDropdown();
// }


_selectItem(evt) {
  const el = evt.currentTarget || evt.target;
  const label = el.textContent.trim();

  // 1️⃣ Get active category (ex: "Regular Fit", "Relaxed Fit", "Oversized")
  const wrapper = this.closest(".prodocut-tab-wrapper-inner");
  let activeCategory = wrapper
    ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
    ?.textContent.trim().toLowerCase();

  if (activeCategory) {
    activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
  }
const showAll = this.hasAttribute('js-display-default-product');

  // 2️⃣ Normalize dataset keys (camelCase → kebab-case)
  let code = null;
  if (activeCategory) {
    const matchAttr = Object.keys(el.dataset).find(key => {
      // convert camelCase → kebab-case
      const kebabKey = key
        .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
        .toLowerCase();
        if (showAll) return el.dataset[key]; 
      return kebabKey.includes(activeCategory);
    });

    if (matchAttr) {
      code = el.dataset[matchAttr];
    }
  }

  // 3️⃣ Fallback
  if (!code) {
    console.warn("No product handle found for", activeCategory, el.dataset);
    return;
  }

  // 4️⃣ If same as current, just toggle
  if (code === this.value) {
    this._toggleDropdown();
    return;
  }

  // 5️⃣ Update selection
  this._clearSelectionStyles();
  el.classList.add("selected");
  this.selectedText.textContent = label;

  this.value = code;
  this.setAttribute("value", code);
  this.setAttribute("text", label);

  if (!evt.silent) {
    this.dispatchEvent(new CustomEvent("change", {
      bubbles: true,
      detail: { value: code }
    }));
  }

  this._toggleDropdown();
}




  _clearSelectionStyles() {
    this.items.forEach(i => i.classList.remove("selected"));
  }

  _showPlaceholder() {
    this.selectedText.textContent =
      this.getAttribute("placeholder") || "Select Fabric";
  }

  _handleOutside(evt) {
    if (!this.contains(evt.target) && this.isOpen) this._toggleDropdown();
  }
}

customElements.define("fabric-dropdown", FabricDropdown);



class mobileFabricDropdown extends HTMLElement {
  static get observedAttributes() { return ["value"]; }
  constructor() {
    super();

    this.selectors = {
      header:           "[js-mobile-fabric-dropdown-header]",
      arrow:            "[js-mobile-fabric-dropdown-arrow]",
      list:             "[js-mobile-fabric-dropdown-list]",
      overlay:          "[js-mobile-fabric-dropdown-overlay]",
      item:             "[js-mobile-fabric-dropdown-item]",
      selectedText:     "[js-mobile-fabric-dropdown-selected-text]",
      container:        "[js-mobile-fabric-dropdown-container]"   
    };

    
    this.header       = this.querySelector(this.selectors.header);
    this.arrow        = this.querySelector(this.selectors.arrow);
    this.list         = this.querySelector(this.selectors.list);
    this.overlay      = this.querySelector(this.selectors.overlay);
    this.items        = this.querySelectorAll(this.selectors.item);
    this.selectedText = this.querySelector(this.selectors.selectedText);

    
    this.isOpen = false;
    this.value  = null;         

    this.init();
  }
connectedCallback() {
    const initial = this.getAttribute("value");
      if (initial) {
        // wait a frame so items are parsed
        requestAnimationFrame(() => (this.selectedValue = initial));
      } else {
        
        requestAnimationFrame(() => {
        const wrapper = this.closest(".prodocut-tab-wrapper-inner.product-tab.medium-up--hide");
        let activeCategory = wrapper
          ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
          ?.textContent.trim().toLowerCase();

        if (activeCategory) {
          activeCategory = activeCategory.replace(/\s+/g, "-");
        }
        const showAll = this.hasAttribute('js-display-default-product');
        // Try to find an item whose dataset matches the active category
        this.items.forEach(item => {
          if (showAll) {
            item.style.display = "";
          }
          else {
            const hasMatch = Object.keys(item.dataset).some(key => {
              const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
              return activeCategory && kebabKey.includes(activeCategory) && item.dataset[key];
            });

            item.style.display = hasMatch ? "" : "none";
          }

        });

        const visibleItem = Array.from(this.items).some(el => el.style.display !== "none");
        if (!visibleItem) {
          this._showPlaceholder();
        }
      });
      }
        // Listen for mobile close button
    const closeBtn = document.querySelector(".mobile_close_fabric");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => this._closeDropdown());
    }

    // Listen for clicks on the overlay container
    if (this.overlay) {
      this.overlay.addEventListener("click", () => this._closeDropdown());
    }
  }

  
  attributeChangedCallback(name, oldVal, newVal) {
    console.log(name, oldVal, newVal);
    
  if (name === "value") {
    if (newVal) {
      requestAnimationFrame(() => {
        this.selectedValue = newVal;
      });
    } else {
      this.value = null;
      this._clearSelectionStyles();
      this._showPlaceholder();
    }
  }
}

  get selectedValue() { return this.value; }
  set selectedValue(val) {
    const match = Array.from(this.items)
      .find(i => i.dataset.fabricProduct === val);
    if (match) this._selectItem({ currentTarget: match, silent: true });
  }

  
  init() {    
    this.header.addEventListener("click",  this._toggleDropdown.bind(this));

    this.items.forEach(item =>
      item.addEventListener("click", this._selectItem.bind(this))
    );

    document.addEventListener("click", this._handleOutside.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._handleOutside.bind(this));
  }

  _toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.list.classList.toggle("open",   this.isOpen);
    this.list.classList.toggle("closed", !this.isOpen);
    this.setAttribute("aria-expanded", this.isOpen);
    if (this.overlay) {
      this.overlay.style.display = this.isOpen ? "block" : "none";
    }
  }

//   _selectItem(evt) {
//   const el   = evt.currentTarget || evt.target;
//   const code = el.dataset.fabricProduct;
//   const label = el.textContent.trim();

//   if (code === this.value) {
//     this._toggleDropdown();
//     return;
//   }

//   this._clearSelectionStyles();
//   el.classList.add("selected");
//   this.selectedText.textContent = label;

//   this.value = code;
//   this.setAttribute("value", code);     
//   this.setAttribute("text", label);     

//   if (!evt.silent) {
//     this.dispatchEvent(new CustomEvent("change", {
//       bubbles: true,
//       detail: { value: code }
//     }));
//   }

//   this._toggleDropdown();
// }

_selectItem(evt) {
  const el = evt.currentTarget || evt.target;
  const label = el.textContent.trim();
  console.log(this)
  // 1️⃣ Find active category (trunks, briefs, vest)
  const wrapper = this.closest(".prodocut-tab-wrapper-inner.product-tab.medium-up--hide");
  let activeCategory = wrapper
      ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
      ?.textContent.trim().toLowerCase();

  if (activeCategory) {
      activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
    }
    const showAll = this.hasAttribute('js-display-default-product');

  // 2️⃣ Get matching data-* attribute
  let code = null;
  if (activeCategory) {
    const matchAttr = Object.keys(el.dataset).find(key => {
        // convert camelCase → kebab-case
        const kebabKey = key
          .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
          .toLowerCase();
        if (showAll) return el.dataset[key];
        return kebabKey.includes(activeCategory);
      });

      if (matchAttr) {
        code = el.dataset[matchAttr];
      }
  }

  // 3️⃣ Fallback if no match found
  if (!code) {
    console.warn("No product handle found for", activeCategory, el.dataset);
    return;
  }

  // 4️⃣ If same as current, just toggle
  if (code === this.value) {
    this._toggleDropdown();
    return;
  }

  // 5️⃣ Set selection
  this._clearSelectionStyles();
  el.classList.add("selected");
  this.selectedText.textContent = label;

  this.value = code;
  this.setAttribute("value", code);
  this.setAttribute("text", label);

  if (!evt.silent) {
    this.dispatchEvent(new CustomEvent("change", {
      bubbles: true,
      detail: { value: code }
    }));
  }

  this._toggleDropdown();
}


  _clearSelectionStyles() {
    this.items.forEach(i => i.classList.remove("selected"));
  }

  _showPlaceholder() {
    this.selectedText.textContent =
      this.getAttribute("placeholder") || "Select Items";
  }

  _handleOutside(evt) {
    if (!this.contains(evt.target) && this.isOpen) this._toggleDropdown();
  }

  _closeDropdown() {
    this.isOpen = false;
    this.list.classList.remove("open");
    this.list.classList.add("closed");
    this.setAttribute("aria-expanded", "false");
    if (this.overlay) {
      this.overlay.style.display = "none";
    }
  }
}

customElements.define("mobile-fabric-dropdown", mobileFabricDropdown);